export const PUBLICATION_STATUSES = [
  'Uncategorized',
  'Ideation',
  'In Progress',
  'To Review',
  'Approuved',
  'Scheduled',
  'Published',
] as const;

export type PublicationStatus = (typeof PUBLICATION_STATUSES)[number];

/** API response shape — Drizzle returns camelCase field names. */
export interface Publication {
  id: string;
  nocodbId: number | null;
  titleEn: string | null;
  titleFr: string | null;
  bodyEn: string | null;
  bodyFr: string | null;
  visualEn: string | null;
  visualFr: string | null;
  visualEnDmsIds: string[];
  visualFrDmsIds: string[];
  channels: string[];
  status: PublicationStatus;
  intentions: string | null;
  xId: string | null;
  xBody: string | null;
  publishDate: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface PublicationListResponse {
  publications: Publication[];
  pageNumber: number;
  pageLength: number;
  total: number;
}

export interface PublicationFilters {
  status?: PublicationStatus;
  channel?: string;
  intentions?: string;
  search?: string;
  sortKey?: string;
  sortDirection?: 'asc' | 'desc';
}

/** PATCH/POST input — DAO expects snake_case keys. */
export interface PublicationPatch {
  title_en?: string | null;
  title_fr?: string | null;
  body_en?: string | null;
  body_fr?: string | null;
  channels?: string[];
  status?: PublicationStatus;
  intentions?: string | null;
  publish_date?: string | null;
  x_id?: string | null;
  x_body?: string | null;
}
